import React from 'react';
//import { useNavigate } from 'react-router-dom';
import './Info.css';

const Info = props => {
    //const navigate = useNavigate();

    function handleBack(){
        props.back(false);
    }

    return (props.trigger) ?(
        <div className='all_info'>
            <div className='info_box_pad'>
                <div className='info_box_back' onClick={handleBack}>{"<Back"}</div>
                <div className='info_box'>
                    <iframe width={"100%"} height={"70%"} src={"https://www.youtube.com/embed/"+props.selection.tag} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    <div className='info_info'>{props.selection.info}</div>
                </div>
            </div>
        </div>
    ) : "";
}

export default Info;